<template>
  <v-container class="py-12">
    <v-row>
      <v-col :cols="12">
        <div class="title-container">
          <div class="title-block">
            <span id="title" class="page-title">Intervalos</span>
            <v-breadcrumbs
              class="app-breadcrumb"
              divider="›"
              :items="[
                {
                  text: 'Home',
                  disabled: false,
                  to: '/home',
                  exact: true
                },
                {
                  text: 'Intervalos',
                  disabled: true,
                  exact: true
                }
              ]"
            ></v-breadcrumbs>
          </div>
          <div class="button-group" style="padding-right: 16px;">
            <!-- v-if="$check(user, ['passengers.create'])" -->
            <v-btn v-if="$check(['intervals.create'])" id="btnNew" type="button" color="primary" elevation="0" to="/intervalos/novo"
              >Incluir</v-btn
            >
          </div>
        </div>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12">
        <v-card class="filter-card">
          <v-card-title class="filter-card-title">Filtros de busca</v-card-title>
          <v-card-text>
            <v-form @submit.prevent="load()">
              <v-row>
                <v-col>
                  <v-text-field
                    dense
                    label="Horário de início"
                    v-model="dataList.filter.init_time"
                    hide-details
                    outlined
                  ></v-text-field>
                </v-col>
                <v-col>
                  <v-text-field
                    dense
                    label="Horário de término"
                    v-model="dataList.filter.end_time"
                    hide-details
                    outlined
                  ></v-text-field>
                </v-col>
              </v-row>

              <v-row>
                <v-col cols="12">
                  <v-btn id="btnFilter" type="submit" color="primary" dark elevation="2"
                    >Filtrar</v-btn
                  >
                </v-col>
              </v-row>
            </v-form>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12">
        <v-card>
          <v-card-text>
            <v-data-table
              :headers="dataList.headers"
              :items="dataList.data"
              @update:items-per-page="pageSizeChanged"
              @update:page="pageChanged"
              :server-items-length="dataList.count"
              :disable-sort="true"
              :loading="dataList.loading"
              no-data-text="Nenhum local encontrado"
              loading-text="Carregando dados..."
              class="app-table hover-table"
              :options.sync="dataList.options"
              :footer-props="dataList.footerOptions"
            >
              <template v-slot:[`item.actions`]="{ item }">
                <v-row align="center">
                  <v-tooltip bottom>
                    <template #activator="{ on }">
                      <v-icon v-if="$check(['intervals.update'])" v-on="on" @click="editItem(item)" size="large">
                        mdi-pencil-outline
                      </v-icon>
                    </template>
                    <span>Editar intervalo</span>
                  </v-tooltip>
                  <v-tooltip bottom>
                    <template #activator="{ on }">
                      <v-icon v-if="$check(['intervals.delete'])" v-on="on" @click="remove(item)" size="large">
                        mdi-delete
                      </v-icon>
                    </template>
                    <span>Remover intervalo</span>
                  </v-tooltip>
                </v-row>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>

        <v-divider></v-divider>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import Vue from 'vue'
import VueLodash from 'vue-lodash'
import _ from 'lodash'
import axios from 'axios'

Vue.use(VueLodash)

export default {
  name: 'LocationsList',

  data: () => ({
    dataset: {
      data: {}
    },
    dataList: {
      filter: {},
      headers: [
        { text: 'ID', value: 'id' },
        { text: 'Horário de início', value: 'init_time' },
        { text: 'Horário de término', value: 'end_time' },
        { text: 'Ações', value: 'actions', sortable: false }
      ],
      data: [],
      loading: false,
      count: 0,
      options: {
        page: 1,
        size: 10,
        sortBy: ['id'],
        sortDesc: [false]
      },
      footerOptions: {
        itemsPerPageText: 'Itens por página:',
        itemsPerPageOptions: [10, 20, 30, 40, 50],
        pageText: '{0}-{1} de {2}'
      }
    },
    deleteDialog: false,
    locationToDelete: null
  }),

  created() {
    this.load()
  },

  methods: {
    pageChanged(page) {
      this.dataList.options.page = page
      this.load()
    },

    pageSizeChanged(size) {
      this.dataList.options.size = size
      this.load(true)
    },

    async load() {
      this.dataList.loading = true

      try {
        const result = await axios.get('api/v2/time-intervals', {
          params: {
            page: this.dataList.options.page,
            limit: 10,
            search: { ...this.dataList.filter }
          }
        })

        this.dataList.data = result.data.content.data

        this.dataList.count = result.data.content.total
      } catch (error) {
        console.log('error ', error)
        this.$dialog.notify.error(this.$codes(error), { position: 'top-right', timeout: 5000 })
      } finally {
        this.dataList.loading = false
      }
    },

    editItem(item) {
      this.$router.push(`intervalos/${item.id}`)
    },

    async remove(item) {
      this.dataList.loading = true

      try {
        const proceedAction = await this.$dialog.confirm({
          text: 'Deseja remover o intervalo?',
          title: 'Remover intervalo',
          actions: {
            false: 'Cancelar',
            true: 'Remover'
          }
        })

        if (!proceedAction) return

        await axios.delete(`api/v2/time-intervals/${item.id}`)

        this.$dialog.notify.success('Intervalo removido com sucesso!', {
          position: 'top-right',
          timeout: 3000
        })
        await this.load()
      } catch (error) {
        console.error('Erro ao remover local:', error)
        this.$dialog.notify.error(`Erro ao remover o intervalo: ${this.$codes(error)}`, {
          position: 'top-right',
          timeout: 5000
        })
      } finally {
        this.dataList.loading = false
      }
    }
  }
}
</script>
